import { render, staticRenderFns } from "./AddSeguroincendioPage.vue?vue&type=template&id=7c9d8d38&"
import script from "./AddSeguroincendioPage.vue?vue&type=script&lang=js&"
export * from "./AddSeguroincendioPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports